document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.lavender-product-overview').forEach((productView) => {
    const subtotal = productView.querySelector('[data-product-subtotal]');
    const quantity = productView.querySelector('.lavender-product-quantity-row .quantity__input');
    const variantPicker = productView.querySelector('variant-radios, variant-selects');
    const form = productView.querySelector('.product-checkout-column form[data-type="add-to-cart-form"]');
    if (!subtotal || !form) return;

    let variants = [];
    try {
      variants = JSON.parse(variantPicker?.querySelector('script[type="application/json"]')?.textContent || '[]');
    } catch (error) {
      console.error('Could not read product variants', error);
    }

    const updateSubtotal = () => {
      const selectedId = form.querySelector('input[name="id"]')?.value;
      const selected = variants.find((variant) => String(variant.id) === String(selectedId));
      const unitPrice = selected ? selected.price : Number(subtotal.dataset.unitPrice);
      const count = Math.max(1, Number(quantity?.value) || 1);
      subtotal.textContent = `₹${new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(Math.round(unitPrice * count / 100))}`;
      if (selected?.featured_image?.src) {
        productView.querySelectorAll('.lavender-product-view-larger, .lavender-product-gallery-caption a').forEach((link) => {
          link.href = selected.featured_image.src;
        });
      }
    };

    quantity?.addEventListener('input', updateSubtotal);
    quantity?.addEventListener('change', updateSubtotal);
    form.querySelector('input[name="id"]')?.addEventListener('change', updateSubtotal);
    updateSubtotal();
  });
});
